import React, { Component } from "react";
import { axiosInstance as axios } from "UTILS/axios.init";
import { getAPIErrorInfo } from "UTILS/errorLookup";
import * as log from "loglevel";

// Custome Components
import Popup from "COMPONENTS/CommonComponents/Modal/Modal";

// Action
import { logoutAction } from "CONFIG/ActionFactory";

// Constant
import { ERROR } from "UTILS/Constants";

// Strings
import { getMessage } from "CONFIG/i18n";

const withErrorHandler = WrappedComponent => {
  return class extends Component {
    constructor(props) {
      super(props);
      this.responseInterceptor = "";
      log.setLevel("error");
    }

    state = {
      errorInfo: "",
      show: false,
      isOnline: true
    };
    onClose = () => {
      this.setState({
        show: false,
        errorInfo: "",
        showModal: false
      });
    };
    componentDidMount() {
      window.addEventListener('online', () => {
        //console.log("withErrorHandler isOnline" );
        this.setState({
          isOnline: true
        }) 
      });

      window.addEventListener('offline', () => {
        //console.log("withErrorHandler isOffline" );
        this.setState({
          isOnline: false
        }) 
      });

      this.responseInterceptor = axios.interceptors.response.use(
        res => {
          this.setState({showModal: false})
          return res;
        },

        error => {
          // console.log("axios interceptor: ", error.code);
          
          let errorInfo = getAPIErrorInfo(error.code, error.response, this.state.isOnline);
          
          if (!errorInfo) {
            errorInfo = error;
          }
          this.setState({
            errorInfo: errorInfo,
            show: true
          });
          if(errorInfo.code==ERROR.NOT_AUTHORIZED){
            this.setState({showModal:true});
          }
          return errorInfo;
        }
      );
    }
    componentWillUnmount() {
      axios.interceptors.response.eject(this.responseInterceptor);
    }

    showModal = () => {
      return (
        <Popup
          show={this.state.showModal}
          isDoubleButton={false}
          message={getMessage("SESSION_EXPIRED")}
          cleanUp={this.logout}
        />
      );
    };

    logout = () => {
      this.setState({showModal:false});
      logoutAction.logoutUser();
    }

    render() {
      return (
        <React.Fragment>
          {this.showModal()}
          <WrappedComponent {...this.props} />
        </React.Fragment>
      );
    }
  };
};
export default withErrorHandler;
